import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export enum AlertTypeEnum {
  Warning,
  Error,
  Info,
}

export interface AlertDialogParameters {
  title?: string;
  closeButtonText?: string;
  messages: string[];
  type: AlertTypeEnum;
}

@Component({
  selector: 'fl-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
})
export class AlertDialogComponent implements OnInit {
  public title: string;
  public buttonText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public params: AlertDialogParameters = {
      title: 'Alert!',
      messages: [''],
      closeButtonText: 'Close',
      type: AlertTypeEnum.Info,
    },
  ) {}

  public ngOnInit() {
    this.title = this.params.title != null ? this.params.title : 'Alert!';
    this.buttonText = this.params.closeButtonText != null ? this.params.closeButtonText : 'Close';
  }

  get alertType() {
    if (this.params.type === AlertTypeEnum.Error) {
      return 'error';
    } else if (this.params.type === AlertTypeEnum.Warning) {
      return 'warning';
    } else {
      return 'info';
    }
  }
}
